import script from "./ConsultarBanco.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsultarBanco.vue?vue&type=script&setup=true&lang=ts"

import "./ConsultarBanco.vue?vue&type=style&index=0&id=477a59c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477a59c4"]])

export default __exports__